import { useContext, useMemo } from "react";
import { Button, ButtonGroup } from "react-bootstrap";
import { CSVLink } from "react-csv";
import { useAuth } from "react-oidc-context";

import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { modalButtonDisplay } from "../../constants";
import { SiteContext } from "../../contexts/siteContext";
import { UserDataContext } from "../../contexts/userDataContext";
import { flattenObject, getIsSysAdmin, isRoutePermitted } from "../../utils";
import { RefreshButton } from "./refreshButton";
import { useDataTableContext } from "./hooks/useDataTableContext";

export const RibbonButtons = ({ children }) => {
	return (
		<ButtonGroup className="ms-3" data-testid="test-ribbonButtons">
			{children}
		</ButtonGroup>
	);
};

export const DataTableRibbonButtons = ({
	selectedRows,
	onClick = () => console.log,
	rows = [],
}) => {
	const {
		refreshTableData,
		dataTableColumnSettings,
		dataTableEditorSettings,
		isFetching,
	} = useDataTableContext();

	const { selectedOrg } = useContext(UserDataContext);
	const { selectedSite } = useContext(SiteContext);

	const { isAuthenticated } = useAuth();
	const isSysAdmin = useMemo(getIsSysAdmin, [isAuthenticated]);

	const csvMapperFn = dataTableColumnSettings?.csvMapperFn || ((x) => [x]);
	const csvData = useMemo(
		() =>
			rows
				.map(({ values }) =>
					csvMapperFn(values).map((x) => flattenObject(x))
				)
				.flat(),
		[rows]
	);
	return (
		<RibbonButtons>
			<CSVLink
				filename={dataTableColumnSettings?.entity}
				data={csvData}
				target="_blank"
				className="btn btn-outline-primary btn-sm"
			>
				<FontAwesomeIcon icon={faDownload} />
			</CSVLink>
			{dataTableEditorSettings?.actions?.map(
				(
					{
						action,
						buttonTitle,
						display,
						isDisabled,
						isDisabledFn = () => isDisabled,
						isVisible,
						permissions,
					},
					index
				) => {
					if (
						isVisible !== false &&
						(display === modalButtonDisplay.BUTTON || !display) &&
						isRoutePermitted(
							{
								...selectedOrg.permissions,
								...selectedSite.permissions,
							},
							permissions,
							isSysAdmin
						)
					) {
						isDisabled = isDisabledFn(selectedRows);

						return (
							<Button
								disabled={isDisabled}
								onClick={onClick(action)}
								key={`btn-${index}-${action}`}
								variant="outline-primary"
								size="sm"
							>
								{buttonTitle || action}
							</Button>
						);
					}
					return null;
				}
			)}
			<RefreshButton onClick={refreshTableData} isSpin={isFetching} />
		</RibbonButtons>
	);
};
